import React, { FunctionComponent } from 'react'
import { useCheckoutConsumerNames, useIsExpress, useMobileLogin, useRegistration } from '../../state'
import { ProfileCard } from '..'
import { TrackingEvent } from '../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'

interface ProfileCardProps {
  setEnableEditName: (enableEditName: boolean) => void
  enableEditName: boolean
}

export const CreateAccountProfileCard: FunctionComponent<ProfileCardProps> = (props) => {
  const { givenNames, surname } = useCheckoutConsumerNames()
  const { enableEditName, setEnableEditName } = props
  const { data: registrationData } = useRegistration()
  const isExpress = useIsExpress()
  const { isMobileLogin } = useMobileLogin()
  const { instrument } = useMonitoringWithEnduringEventProperties()
  const givenName = registrationData?.givenNames ?? givenNames ?? ''
  const otherGivenName = registrationData?.otherGivenNames ?? ''.charAt(0)
  const surName = registrationData?.surname ?? surname ?? ''

  const profileCardName = `${givenName} ${otherGivenName} ${surName}`.trim()
  const onEdit = instrument(TrackingEvent.PRESSED_CREATE_ACCOUNT_PAGE_EDIT, () => setEnableEditName(!enableEditName))
  const profileHeader = profileCardName.length > 0 ? profileCardName : ' '
  const hideSubHeader = !isExpress && isMobileLogin
  const showOnEdit = !isExpress && !enableEditName && { onEdit }

  return <ProfileCard header={profileHeader} hideSubheader={hideSubHeader} {...showOnEdit} />
}
